import { useEffect, useState } from "react";

/** Viewport width from which the console shows a rail and master-detail panes. */
export const WIDE_QUERY = "(min-width: 900px)";

function matches(): boolean {
  // Without matchMedia (old webviews, jsdom) the dense desktop layout is used.
  if (typeof window.matchMedia !== "function") return true;
  return window.matchMedia(WIDE_QUERY).matches;
}

/**
 * True on a wide viewport. Narrow viewports and the Telegram Mini App collapse
 * to single-pane drill-down, driven by the route.
 */
export function useWideLayout(): boolean {
  const [wide, setWide] = useState(matches);
  useEffect(() => {
    if (typeof window.matchMedia !== "function") return undefined;
    const query = window.matchMedia(WIDE_QUERY);
    const onChange = () => {
      setWide(query.matches);
    };
    onChange();
    query.addEventListener("change", onChange);
    return () => {
      query.removeEventListener("change", onChange);
    };
  }, []);
  return wide;
}
